import React from "react";
import "../styles/Section.css";

const posts = [
  {
    title: "Why Businesses Need Custom Software",
    date: "March 2026",
    excerpt: "Custom software provides competitive advantage and scalability."
  },
  {
    title: "Cloud Migration Strategy",
    date: "February 2026",
    excerpt: "How companies can safely migrate infrastructure to the cloud."
  }
];

const Blog = () => {
  return (
    <section id="blog" className="section">
      <h2>Insights</h2>
      <div className="cards">
        {posts.map((post, index) => (
          <div key={index} className="card animate">
            <h3>{post.title}</h3>
            <small>{post.date}</small>
            <p>{post.excerpt}</p>
            <button className="learn-btn">Read More</button>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Blog;